import React, { useState } from 'react';
import { Card } from 'flowbite-react';
import teacher from '../../assets/teacher.svg';
import student from '../../assets/student.svg';

const LearnMore = () => {
  const [isTeacherHovered, setIsTeacherHovered] = useState(false);

  const goToRegister = () => {
    window.location.replace('/register');
  };

  return (
    <div>
      <div
        id="resources"
        className="w-full min-h-screen bg-white flex flex-col items-center justify-center py-12 sm:py-16 lg:py-20 px-4"
      >
        {/* Responsive Heading */}
        <h1 className="font-thin text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl mb-8 sm:mb-12 md:mb-16 lg:mb-20 text-center max-w-5xl leading-tight">
          Learn and Teach with EduBahamas
        </h1>

        {/* Responsive Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 w-full max-w-6xl px-4 sm:px-6">
          
          {/* Teacher/Tutor Card (Coming Soon) */}
          <div
            className="relative w-full"
            onMouseEnter={() => setIsTeacherHovered(true)}
            onMouseLeave={() => setIsTeacherHovered(false)}
          >
            <Card
              horizontal
              imgSrc={teacher}
              className={`w-full h-full shadow-lg transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-105
                ${isTeacherHovered ? 'ring-2 ring-gray-200' : ''}
                opacity-90`}
            >
              {/* Title with Badge */}
              <div className="flex items-start gap-2 sm:gap-3">
                <h5 className="flex-1 text-base sm:text-lg md:text-xl lg:text-2xl font-bold tracking-tight text-gray-900">
                  Register as a Teacher or Tutor
                </h5>

                <span
                  className={`text-[10px] sm:text-[11px] px-2 py-1 rounded-full bg-gray-200 text-gray-700 transition
                    whitespace-nowrap min-w-max flex-none
                    ${isTeacherHovered ? 'opacity-100' : 'opacity-0'}`}
                >
                  Coming&nbsp;Soon
                </span>
              </div>

              <p className="font-normal text-gray-700 text-xs sm:text-sm md:text-base mt-2">
                For educators and tutors. Classroom tools and student tracking are coming soon.
              </p>
            </Card>
          </div>

          {/* Student Card (Clickable) */}
          <div
            className="relative w-full"
            onClick={goToRegister}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter') goToRegister();
            }}
          >
            <Card
              horizontal
              imgSrc={student}
              className="w-full h-full hover:cursor-pointer shadow-lg transition ease-in-out delay-100 hover:-translate-y-1 hover:scale-105"
            >
              <h5 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold tracking-tight text-gray-900">
                Register as a Student
              </h5>
              <p className="font-normal text-gray-700 text-xs sm:text-sm md:text-base mt-2">
                Test your knowledge with quizzes and track real progress.
              </p>
            </Card>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default LearnMore;